import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../helpers/Utility';
import { getCookie, setCookie } from 'helpers/saveToCookies';
import {
  ACCESS_TOKEN,
  DEVICE_INFORMATION,
  RAYA_APPS_DATA,
  USER_LOGIN_DATA
} from 'common/constants';
import {
  getDecryptJwtToken,
  getDecryptRayaAppsData,
  getDeviceInformation
} from 'helpers/getQueryStringUrl';

/**
 * decrypt token from cookie for use to initial state
 */
const decryptDecodedToken = getDecryptJwtToken(getCookie(USER_LOGIN_DATA));

/**
 * get device information from cookie for use to initial state
 */
const deviceInformation = getDeviceInformation(getCookie(DEVICE_INFORMATION));

/**
 * decrypt raya apps data from cookie for use to initial state
 */
const decryptDecodedDataRayaApps = getDecryptRayaAppsData(
  getCookie(RAYA_APPS_DATA)
);

// eslint-disable-next-line quotes
const { clientId, clientSecret, VTtoken, partnerId, subCode, referralCode } =
  decryptDecodedToken ? decryptDecodedToken : {};

const { deviceId, deviceName, deviceType } = deviceInformation
  ? deviceInformation
  : {};

const { noHpFlexi, noHpRaya, noHpFlexiNew, isRayaAgreement, status, code } =
  decryptDecodedDataRayaApps ? decryptDecodedDataRayaApps : {};

const initialState = {
  appTnC: '',
  splashScreen: '',
  error: '',
  oauthToken: getCookie(ACCESS_TOKEN) || '',
  oauthExpiredTime: '',
  phoneNo: localStorage.getItem('phoneNo') || noHpFlexi || '',
  phonePrincipal: localStorage.getItem('phonePrincipal') || '',
  noHpRaya: localStorage.getItem('noHpRaya') || noHpRaya || '',
  noHpFlexiNew: localStorage.getItem('noHpFlexiNew') || noHpFlexiNew,
  newPhoneNo: '',
  isLogin: false,
  isBriEmployee: false,
  registeredPin: '',
  typedPin: '',
  newPin: '',
  homePath: '/',
  userProfile: '',
  clientId: clientId ? clientId : '',
  clientSec: clientSecret ? clientSecret : '',
  VTtoken: VTtoken ? VTtoken : '',
  partnerId: partnerId ? partnerId : '',
  subCode: subCode ? subCode : '',
  referralCode: referralCode ? referralCode : '',
  deviceId: deviceId ? deviceId : '',
  deviceName: deviceName ? deviceName : '',
  deviceType: deviceType ? deviceType : '',
  isTncAgreement: 'N',
  statusAuthFlowRaya: status || '',
  codeAuthFlowRaya: code || '',
  dataRayaAppsAuthFlow: decryptDecodedDataRayaApps
    ? decryptDecodedDataRayaApps
    : {},
  isRayaAgreement: !(
    isRayaAgreement !== 'Y' &&
    localStorage.getItem('isRayaAgreement') !== 'true'
  ),
  errorRayaAgreement: false,
  updateTncAgreement: false,
  geoLocation: null,
  permissionGeolocation: 'granted',
  resultValidateToken: {
    token: '',
    appStatus: '',
    status: ''
  },
  hasLoginSession: false,
  notifPromoPermission: false
};

const setAppTnC = (state, action) => {
  return updateObject(state, { appTnC: action.appTnC });
};

const setSplashScreen = (state, action) => {
  return updateObject(state, { splashScreen: action.data });
};

const setError = (state, action) => {
  return updateObject(state, { error: action.error });
};

const setOauthToken = (state, action) => {
  setCookie(ACCESS_TOKEN, action.token, 10);

  return updateObject(state, {
    oauthToken: action.token,
    oauthExpiredTime: action.expiredTime
  });
};

const setPhoneNumber = (state, action) => {
  return updateObject(state, { phoneNo: action.phoneNo });
};

const setNewPhoneNo = (state, action) => {
  return updateObject(state, { newPhoneNo: action.phoneNo });
};

const setPhoneNumberRaya = (state, action) => {
  return updateObject(state, { noHpRaya: action.noHpRaya });
};

const setPhoneNumberFlexiNew = (state, action) => {
  return updateObject(state, { noHpFlexiNew: action.noHpFlexiNew });
};

const setUserId = (state, action) => {
  return updateObject(state, { phonePrincipal: action.phonePrincipal });
};

const setRegisteredPin = (state, action) => {
  return updateObject(state, { registeredPin: action.pin });
};

const inputPinLogin = (state, action) => {
  return updateObject(state, {
    typedPin: state.typedPin + action.typedPin
  });
};

const setNewPin = (state, action) => {
  return updateObject(state, { newPin: action.newPin });
};

const delPinLogin = state => {
  return updateObject(state, {
    typedPin: state.typedPin.slice(0, -1)
  });
};

const resetTypedPin = state => updateObject(state, { typedPin: '' });

const setHomePath = (state, action) => {
  return updateObject(state, { homePath: action.path });
};

const setIsLogin = (state, action) => {
  return updateObject(state, { isLogin: action.status });
};

const setUserProfile = (state, action) => {
  return updateObject(state, { userProfile: action.data });
};

const setInfoPromoPermission = (state, action) => {
  return updateObject(state, { notifPromoPermission: action.status });
};

const setParameterAccess = (state, action) => {
  return updateObject(state, {
    clientId: action.params.clientId,
    clientSec: action.params.clientSecret,
    VTtoken: action.params.VTtoken,
    partnerId: action.params.partnerId,
    subCode: action.params.subCode || '',
    referralCode: action.params.referralCode || ''
  });
};

const setDeviceInformation = (state, action) => {
  return updateObject(state, {
    deviceId: action.deviceInformation.deviceId,
    deviceName: action.deviceInformation.deviceName,
    deviceType: action.deviceInformation.deviceType
  });
};

const setIsTncAgreement = (state, action) => {
  return updateObject(state, { isTncAgreement: action.isTncAgreement });
};

const setDataRayaApps = (state, action) => {
  return updateObject(state, { dataRayaAppsAuthFlow: action.data });
};

const setStatusAuthFlowRaya = (state, action) => {
  return updateObject(state, {
    statusAuthFlowRaya: action.statusAuthFlowRaya
  });
};

const setCodeAuthFlowRaya = (state, action) => {
  return updateObject(state, {
    setCodeAuthFlowRaya: action.setCodeAuthFlowRaya
  });
};

const setIsRayaAgreement = (state, action) => {
  localStorage.setItem(
    'isRayaAgreement',
    action.isRayaAgreement !== 'Y' ? 'false' : 'true'
  );

  return updateObject(state, {
    isRayaAgreement: action.isRayaAgreement !== 'Y' ? false : true
  });
};

const setErrorRayaAgreement = (state, action) => {
  return updateObject(state, { errorRayaAgreement: action.errorRayaAgreement });
};

const setUpdateTncAgreement = (state, action) => {
  return updateObject(state, { updateTncAgreement: action.updateTncAgreement });
};

const setPosition = (state, action) => {
  return updateObject(state, { geoLocation: action.position });
};

const setPermissionGeolocation = (state, action) => {
  return updateObject(state, { permissionGeolocation: action.permission });
};

const setResultValidateToken = (state, action) => {
  return updateObject(state, {
    resultValidateToken: action.resultValidateToken
  });
};

const setHasLoginSession = (state, action) => {
  return updateObject(state, { hasLoginSession: action.hasLoginSession });
};

const handlers = {
  [actionTypes.SET_APP_TNC]: setAppTnC,
  [actionTypes.SET_SPLASH_SCREEN]: setSplashScreen,
  [actionTypes.SET_ERROR]: setError,
  [actionTypes.SET_OAUTH_TOKEN]: setOauthToken,
  [actionTypes.SET_PHONE_NUMBER]: setPhoneNumber,
  [actionTypes.SET_USER_ID]: setUserId,
  [actionTypes.SET_REG_PIN]: setRegisteredPin,
  [actionTypes.SET_NEW_PIN]: setNewPin,
  [actionTypes.TYPING_PIN]: inputPinLogin,
  [actionTypes.DEL_PIN]: state => delPinLogin(state),
  [actionTypes.RESET_TYPED_PIN]: state => resetTypedPin(state),
  [actionTypes.SET_HOME_PATH]: setHomePath,
  [actionTypes.SET_IS_LOGIN]: setIsLogin,
  [actionTypes.SET_PROFILE_DATA]: setUserProfile,
  [actionTypes.SET_PARAMETER_ACCESS]: setParameterAccess,
  [actionTypes.SET_NEW_PHONENO]: setNewPhoneNo,
  [actionTypes.SET_DEVICE_INFORMATION]: setDeviceInformation,
  [actionTypes.SET_IS_TNC_AGREEMENT]: setIsTncAgreement,
  [actionTypes.SET_DATA_RAYA_APPS]: setDataRayaApps,
  [actionTypes.SET_PHONE_NUMBER_RAYA]: setPhoneNumberRaya,
  [actionTypes.SET_PHONE_NUMBER_FLEXI_NEW]: setPhoneNumberFlexiNew,
  [actionTypes.SET_STATUS_AUTH_FLOW_RAYA]: setStatusAuthFlowRaya,
  [actionTypes.SET_CODE_AUTH_FLOW_RAYA]: setCodeAuthFlowRaya,
  [actionTypes.SET_IS_RAYA_AGREEMENT]: setIsRayaAgreement,
  [actionTypes.SET_ERROR_RAYA_AGREEMENT]: setErrorRayaAgreement,
  [actionTypes.SET_UPDATE_TNC_AGREEMENT]: setUpdateTncAgreement,
  [actionTypes.SET_POSITION]: setPosition,
  [actionTypes.SET_PERMISSION_GEOLOCATION]: setPermissionGeolocation,
  [actionTypes.SET_PERMISSION_INFO_PROMO]: setInfoPromoPermission,
  [actionTypes.SET_RESULT_VALIDATE_TOKEN]: setResultValidateToken,
  [actionTypes.SET_HAS_LOGIN_SESSION]: setHasLoginSession
};

const reducer = (state = initialState, action) => {
  const handler = handlers[action.type];

  return handler ? handler(state, action) : state;
};

export default reducer;
